// extracted by mini-css-extract-plugin
export default {"labelWrapper":"FieldHourInput_labelWrapper__22TKr"};